import { render } from "./PowerStations.vue?vue&type=template&id=c650b3d6"
import script from "./PowerStations.vue?vue&type=script&lang=js"
export * from "./PowerStations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__